function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initMotionCommon = function initMotionCommon(duration) {
  return {
    animationDuration: duration,
    animationFillMode: 'both'
  };
}; // FIXME: origin less code seems same as initMotionCommon. Maybe we can safe remove


var initMotionCommonLeave = function initMotionCommonLeave(duration) {
  return {
    animationDuration: duration,
    animationFillMode: 'both'
  };
};

export var initMotion = function initMotion(motionCls, inKeyframes, outKeyframes, duration) {
  var _ref;

  var sameLevel = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var sameLevelPrefix = sameLevel ? '&' : '';
  return _ref = {}, _defineProperty(_ref, "\n      ".concat(sameLevelPrefix).concat(motionCls, "-enter,\n      ").concat(sameLevelPrefix).concat(motionCls, "-appear\n    "), Object.assign(Object.assign({}, initMotionCommon(duration)), {
    animationPlayState: 'paused'
  })), _defineProperty(_ref, "".concat(sameLevelPrefix).concat(motionCls, "-leave"), Object.assign(Object.assign({}, initMotionCommonLeave(duration)), {
    animationPlayState: 'paused'
  })), _defineProperty(_ref, "\n      ".concat(sameLevelPrefix).concat(motionCls, "-enter").concat(motionCls, "-enter-active,\n      ").concat(sameLevelPrefix).concat(motionCls, "-appear").concat(motionCls, "-appear-active\n    "), {
    animationName: inKeyframes,
    animationPlayState: 'running'
  }), _defineProperty(_ref, "".concat(sameLevelPrefix).concat(motionCls, "-leave").concat(motionCls, "-leave-active"), {
    animationName: outKeyframes,
    animationPlayState: 'running',
    pointerEvents: 'none'
  }), _ref;
};